module.exports = __webpack_public_path__ + "img/guide1-8.1672f40d.png";